// extracted by mini-css-extract-plugin
module.exports = {"warmthGuide":"styles_warmthGuide__MxZF5","warmthModel":"styles_warmthModel__1leTp"};